import moment from 'moment-timezone';

export const BOD_CANCEL_WARNING =
  'BoD may be running between 1:30 and 3:30 AM ET. It is safer to cancel after 3:30 AM ET. You may still proceed.';

/**
 * True when current time is in the BoD risk window: 01:30 inclusive → 03:30 exclusive ET.
 * @param {moment.Moment} [now]
 */
export function isBodRiskWindow(now = moment.tz('America/New_York')) {
  const minutes = now.hours() * 60 + now.minutes();
  return minutes >= 90 && minutes < 210;
}

/**
 * Confirm description for cancel actions, with BoD warning appended when in window.
 * @param {string} baseDescription
 * @param {moment.Moment} [now]
 */
export function cancelConfirmDescription(
  baseDescription = 'You are about to cancel this transaction, please confirm.',
  now
) {
  if (!isBodRiskWindow(now)) {
    return baseDescription;
  }
  return `${baseDescription}\n\n${BOD_CANCEL_WARNING}`;
}
